import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Analytics = /*#__PURE__*/function () {
  function Analytics() {
    var _this = this;

    _classCallCheck(this, Analytics);

    _defineProperty(this, "providers", []);

    _defineProperty(this, "eventsQueue", []);

    _defineProperty(this, "isInitialized", false);

    _defineProperty(this, "isPrepared", false);

    _defineProperty(this, "executeProvidersInitialize", function () {
      var _iterator = _createForOfIteratorHelper(_this.providers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var provider = _step.value;
          provider.init();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      _this.isInitialized = true;

      if (_this.eventsQueue.length) {
        _this.eventsQueue.forEach(function (_ref) {
          var data = _ref.data,
              providers = _ref.providers;

          _this.sendEvent(data, providers);
        });

        _this.eventsQueue = [];
      }

      window.dispatchEvent(new CustomEvent('initializedAnalyticsProviders'));
    });
  }

  _createClass(Analytics, [{
    key: "initialize",
    value:
    /**
     * @deprecated use `.prepare`
     * This method waits for user event before resolve the promise, some places still "await" for it.
     * This isn't needed as we can just call it and queue events.
     * This function should be replaced with `prepare`.
     */
    function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(providers) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve) {
                  var _iterator2 = _createForOfIteratorHelper(providers),
                      _step2;

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var provider = _step2.value;

                      _this2.providers.push(provider);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }

                  _this2.isPrepared = true;
                  window.addEventListener('initializedAnalyticsProviders', function () {
                    resolve(_this2.providers);
                  });
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }() // Creates a list with all the providers that will be used for analytics, used before loading the providers

  }, {
    key: "prepare",
    value: function prepare(providers) {
      var _iterator3 = _createForOfIteratorHelper(providers),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var provider = _step3.value;
          this.providers.push(provider);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this.isPrepared = true;
    }
  }, {
    key: "sendEvent",
    value: function () {
      var _sendEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, providers) {
        var collection, _iterator4, _step4, provider, _iterator5, _step5, pr;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.isInitialized) {
                  _context2.next = 3;
                  break;
                }

                this.eventsQueue.push({
                  data: data,
                  providers: providers
                });
                return _context2.abrupt("return");

              case 3:
                collection = [];
                _iterator4 = _createForOfIteratorHelper(this.providers);

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    provider = _step4.value;

                    if (!providers) {
                      if (provider.isActive) {
                        collection.push(provider.sendEvent(data));
                      }
                    } else {
                      _iterator5 = _createForOfIteratorHelper(providers);

                      try {
                        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                          pr = _step5.value;

                          if (pr.name === provider.constructor.name) {
                            collection.push(provider.sendEvent(data));
                          }
                        }
                      } catch (err) {
                        _iterator5.e(err);
                      } finally {
                        _iterator5.f();
                      }
                    }
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                return _context2.abrupt("return", Promise.all(collection));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendEvent(_x2, _x3) {
        return _sendEvent.apply(this, arguments);
      }

      return sendEvent;
    }()
  }]);

  return Analytics;
}();

export { Analytics as default };